<template>
    <div class="sakura-box-detail">
      <div class="maskLoading" v-show="loading">
        <img src="@/assets/images/load.svg" alt />
      </div>
      <div class="nav-bar">
        <img class="nav-return" @click="toBack" src="@/assets/sakuraBox/icon-black-return.png" alt="">
        存档详情
      </div>
      <div class="tag-help" @click="modelType = 3">怎么使用存档</div>
      <div style="clear:both"></div>
      <div class="to-top" @click="toTop">顶部</div>
      <div class="detail-block">
        <div class="card-name ellipsis">{{detailData.title}}</div>
        <div class="user-info ellipsis">
          <img :src="detailData.avatar" alt="">
          {{detailData.nickname}}
          <span>{{detailData.created_at}}</span>
        </div>
        <div class="card-cover">
          <img :src="detailData.sm_image +'?imageView2/3/w/636/h/366'" alt="">
        </div>
        <div class="card-desc">{{detailData.intro}}</div>
        <div class="card-tag">
            存档标签
            <span v-for="tag in detailData.tags" :key="tag.id">{{tag.name}}</span>
        </div>
        <div class="card-operation">
            <img @click="copyRecordId(detailData.game_arc_id)" src="@/assets/sakuraBox/card-btn-copy.png" class="card-btn active copyName">
            <div v-if="detailData.is_edit === 0" class="edit-status edit-status-pink">该存档不可编辑</div>
            <div v-if="detailData.is_edit === 1" class="edit-status edit-status-green">该存档可编辑</div>
        </div>
      </div>
      <div class="detail-block" v-if="imageList.length !== 0">
        <div class="img-list-title">存档详情</div>
        <div class="detail-img" v-for="(img, imgIndex) in imageList" :key="img" @click="showBigImage(imgIndex)">
            <img :src="img +'?imageView2/3/w/636'" alt="">
        </div>
      </div>
      <div class="block-name">
          <img src="@/assets/sakuraBox/title-block-recommend.png" alt="">
      </div>
      <div class="detail-block" style="padding: 0 0.15rem">
        <div class="recommend-box" v-for="item in recommendList" :key="item.id">
          <div class="re-left"  @click="sukuraBoxArcDetail(item.id)">
            <img :src="item.sm_image +'?imageView2/3/w/292/h/168'" alt="">
          </div>
          <div class="re-right">
            <div class="re-right-title ellipsis"  @click="sukuraBoxArcDetail(item.id)">{{item.title}}</div>
            <div class="re-right-user ellipsis"  @click="sukuraBoxArcDetail(item.id)">
              <img :src="item.avatar" alt="">
              {{item.nickname}}
            </div>
            <div class="collent-count" @click="sukuraBoxOpArc(item, 1)">
                <van-loading v-show="item.praiseLoading" type="spinner" size="16"></van-loading>
            </div>
            <div class="btn-re-detail active" @click="sukuraBoxArcDetail(item.id)"></div>
          </div>
        </div>
      </div>
      <Model @openPanel="openPanel" :modelType='modelType' @closePanel="closePanel"></Model>
      <ShowBigImage ref="ShowBigImage" :currIndex="currIndex" :imgList="imageList" :show.sync="showBigImg"></ShowBigImage>
    </div>
</template>

<script>
import Clipboard from 'clipboard'
import active from '@/utils/axios/index';
import Model from './components/Model.vue'
import ShowBigImage from "@/components/ShowBigImage/index.vue"
import { mapState } from "vuex";
import config from "@/../config";
export default {
  name:'SakuraBoxDetailApp',
  components: {
    Model,
    ShowBigImage
  },
  data() {
    return {
        arc_id: '',
        detailData:{},
        recommendList:[],
        loading:false,
        modelType:false,
        showBigImg:false,
        currIndex: 1,
        isApp:false
    }
  },
  computed:{
    imageList(){
      return this.detailData.xl_image ? this.detailData.xl_image.split(',') : []
    },
    ...mapState([
      "isGuest"
    ]),
  },
  mounted(){
    window.nativeLogin = this.getuuid
    this.arc_id = this.$route.params.arc_id || window.localStorage.getItem('arc_id')
    if(this.$route.params.arc_id){
      window.localStorage.setItem('arc_id', this.arc_id)
    }
    this.sukuraBoxArcDetail()
  },
  methods:{
    showBigImage(currIndex){
      this.showBigImg = true
      this.currIndex = currIndex + 1
      this.$refs.ShowBigImage.$refs.myswiper.$swiper.slideTo(currIndex)
    },
    closePanel(){
      this.modelType = false
    },
    openPanel(type){
      this.modelType = type
    },
    // 复制存档ID
    copyRecordId(code) {
      // this.modelType = 2
      this.$tea('event_sakura_box_arc_op_click',{ sakura_arc_id: this.detailData.id, sakura_op: 4, source: 'sakuraBoxApp' }) // 单个存档的分享次数、点赞次数、收藏次数、复制ID次数
      let clipboard = new Clipboard('.copyName', {
        text: function () {
          return code
        }
      });
      clipboard.on('success', e => {
        this.$toast('已复制到剪切板');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$toast('复制失败');
        clipboard.destroy();
      });
    },
    toTop(){
      try{
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }catch{
        window.scrollTo(0,0) 
      }
    },
    toBack(){
      this.$router.go(-1)
    },
    sukuraBoxArcDetail(id){
      if(id){
        this.arc_id = id
      }
      this.loading = true
      active.sukuraBoxArcDetail(config.SAKURA_BASE_URL + '/api/sakura/arcDetail',{
        arc_id: id || this.arc_id || window.localStorage.getItem('arc_id')
      }).then(res =>{
        if(res.return_code == 200 || res.code == 200){
          window.localStorage.setItem('arc_id', this.arc_id)
          this.detailData = res.data
          this.sukuraBoxRecommend(res.data.uid, res.data.id)
          this.toTop()
        }else{
          this.loading = false
          this.$toast(res.return_msg || res.message || res.msg)
        }
      })
    },
    sukuraBoxRecommend(uid, id){ // uid为当前帖子发布人的uid
      active.sukuraBoxRecommend(config.SAKURA_BASE_URL + '/api/sakura/recommend',{ uid, arc_id: id, _token: window.localStorage.getItem('sakuraToken') }).then(res =>{
        this.loading = false
        if(res.return_code == 200 || res.code == 200){
          this.recommendList = res.data
        }else{
          this.$toast(res.return_msg || res.message || res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
  .ellipsis{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .nav-bar{
    width: 100%;
    height: 53px;
    line-height: 53px;
    text-align: center;
    font-size: 17px;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }
  .nav-return{
    width: 11px;
    height: 19px;
    position: absolute;
    left: 17px;
    top: 17px;
  }
  .nav-share{
    width: 19px;
    height: 19px;
    position: absolute;
    right: 19px;
    top: 34px;
  }
  .sakura-box-detail{
    background: #FFF0F0;
    min-height: 100vh;
    padding-bottom: 45px;
    padding-top: 94px;
    width: 100%;
    overflow-x: hidden;
  }
  .sakura-box-detail >>> .van-skeleton__row{
    background: white;
  }
  .sakura-box-detail >>> .van-skeleton__title{
    background: white;
  }
  .tag-help{
    color: #C53978;
    font-size: 12px;
    width: 108px;
    height: 24px;
    line-height: 24px;
    padding-left: 25px;
    background-color: #FFD6E4;
    border-radius: 30px;
    background-image: url('~assets/sakuraBox/tag-help.png');
    background-repeat: no-repeat;
    background-size: 13px;
    background-position: left 7px center;
    position: absolute;
    top: 63px;
    right: 12px;
  }
  .detail-block{
    width: 351px;
    margin: 0 auto;
    padding: 15px 15px 5px 15px;
    background: white;
    border-radius: 9px;
    border:solid 1px #FA7CB5;
    margin-bottom: 12px;
  }
  .card-tag{
    font-size: 13px;
    color: #757575;
    padding-left: 19px;
    background: url('~assets/sakuraBox/card-tag.png') no-repeat;
    background-size: 13px;
    background-position: top 5px left;
  }
  .card-tag span{
    display: inline-block;
    background: #FEF2F7;
    border-radius: 3px;
    padding: 0 5px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #E33D72;
    margin: 2px 3px;
    position: relative;
  }
  .card-name{
    height: 35px;
    font-size: 21px;
    font-weight: 500;
    color: #383838;
    line-height: 21px;
  }
  .user-info img{
    width: 27px;
    height: 27px;
    border-radius: 50%;
    margin-right: 6px;
  }
  .user-info{
    font-size: 13px;
    font-weight: 400;
    color: #575757;
    line-height: 27px;
    position: relative;
    padding-right: 100px;
  }
  .user-info span{
    position: absolute;
    right: 0;
    top: 50%;
    font-size: 10px;
    color: #696969;
    transform: scale(0.8) translate(10%,-55%);
  }
  .card-cover{
    width: 318px;
    height: 183px;
    border-radius: 10px;
    object-fit: cover;
    overflow: hidden;
    margin: 8px auto;
  }
  .card-cover img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .card-desc {
    font-size: 15px;
    font-weight: 400;
    color: #575757;
    line-height: 21px;
    margin-bottom: 12px;
    word-break: break-all;
  }
  .card-operation{
    margin: 12px auto;
    position: relative;
  }
  .card-btn{
    width: 143px;
    height: 32px;
  }
  .active:active{
    transform: scale(0.9);
  }
  .edit-status{
    font-size: 12px;
    font-weight: 400;
    color: #E33D72;
    line-height: 14px;
    padding: 5px 8px;
    border-radius: 3px;
    text-align: center;
    display: inline-block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .edit-status-pink{
    color: #E33D72;
    border: 1px solid #E33D72;
  }
  .edit-status-green{
    color: #2FBCA5;
    border: 1px solid #2FBCA5;
  }
  .card-footer-1{
    width: 100%;
    height: 40px;
    border-top:solid 1px RGBA(203, 203, 203, 0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
  }
  .footer-btn img{
    width: 14px;
    height: 12px;
    display: inline-block;
    transform: translateY(-1px);
  }
  .footer-btn{
    font-size: 12px;
    height: 36px;
    color: #555;
    line-height: 42px;
    transform: scale(0.85) translateX(6%);
    width: 100px;
    text-align: center;
  }
  .img-list-title{
    font-size: 13px;
    font-weight: 400;
    color: #757575;
    line-height: 16px;
    margin-bottom: 0.15rem;
  }
  .detail-img{
    width: 318px;
    margin-bottom: 12px;
    height: 183px;
    border-radius: 10px;
    overflow: hidden;
  }
  .detail-img img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .to-top{
    width: 60px;
    height: 30px;
    opacity: 0.3;
    position: fixed;
    right: 0;
    bottom: 30px;
    border-radius: 15px 0 0 15px;
    color: white;
    line-height: 30px;
    padding-left: 28px;
    background-image: url('~assets/sakuraBox/to-top.png');
    background-repeat: no-repeat;
    background-size: 14px 11px;
    background-position: left 10px center;
    background-color: #000000;
    font-size: 12px;
    z-index: 5;
  }
  .block-name{
      width: 232px;
      height: 24px;
      margin: 0.17rem auto 0.2rem auto;
      background: url('~assets/sakuraBox/title-bg.png') no-repeat;
      background-size: 100% 18px;
      background-position: center bottom;
      position: relative;
  }
  .block-name img{
      width: 103px;
      height: 24px;
      margin: 0 auto;
      display: block;
  }
  .recommend-box{
    padding: 15px 0;
    border-bottom:solid 1px RGBA(203, 203, 203, 0.5);
    height: 113px;
  }
  .detail-block .recommend-box:last-child{
    border-bottom: none;
  }
  .re-left{
    width: 146px;
    height: 84px;
    border-radius: 10px;
    overflow: hidden;
    float: left;
  }
  .re-left img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .re-right{
    float: right;
    width: 156px;
    position: relative;
    height: 83px;
  }
  .re-right-title{
    font-size: 14px;
    font-weight: 500;
    color: #383838;
    line-height: 28px;
    margin-bottom: 2px;
  }
  .re-right-user{
    font-size: 12px;
    color: #575757;
  }
  .re-right-user img{
    width: 27px;
    height: 27px;
    border-radius: 50%;
    margin-right: 4px;
  }
  .btn-re-detail{
    width: 52px;
    height: 24px;
    background: url('~assets/sakuraBox/btn-re-detail.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .collent-count{
    margin-top: 8px;
    font-size: 12px;
    color:#555555;
    transform: scale(0.8) translateX(-12.5%);
  }
  .collent-count img{
    width: 14px;
    height: 12px;
    margin-right: 6px;
    transform: translateY(-1px);
  }
  .maskLoading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99;
    background: rgba(245, 156, 194, 0.98);
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .maskLoading img {
    display: block;
    width: 0.4rem;
    height: 0.4rem;
    animation: loading 2s linear 0s infinite;
  }
  @keyframes loading {
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
  }
</style>
